import { render } from "./BCanvas.vue?vue&type=template&id=42289991"
import script from "./BCanvas.vue?vue&type=script&lang=js"
export * from "./BCanvas.vue?vue&type=script&lang=js"

import "./BCanvas.vue?vue&type=style&index=0&id=42289991&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__